import React from 'react';
import { Copy, Check } from 'lucide-react';
import { Prompt } from '../../types';

interface FooterActionsProps {
  copied: boolean;
  handleCopy: () => void;
  canManagePrompt: boolean;
  prompt: Prompt;
  onEdit?: (prompt: Prompt) => void;
  onDelete?: (id: string) => void;
}

const FooterActions: React.FC<FooterActionsProps> = ({
  copied,
  handleCopy,
  canManagePrompt,
  prompt,
  onEdit,
  onDelete,
}) => (
            <div className="border-t border-dark-700 pt-5 pb-3 sm:px-3">
              <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">

                <div className="flex justify-end">
                  <button
                    onClick={handleCopy}
                    className="flex items-center gap-2 btn-primary"
                  >
                    {copied ? (
                      <>
                        <Check size={18} />
                        Copiado!
                      </>
                    ) : (
                      <>
                        <Copy size={18} />
                        Copiar prompt
                      </>
                    )}
                    
                  </button>
                </div>


 {canManagePrompt && (
                <div className="flex flex-wrap gap-3">
                   
                  {onEdit && (
                    
                    <button
                      type="button"
                      onClick={() => onEdit(prompt)}
                      className="btn-secondary"
                    >
                      Editar
                    </button>
                  )}
                 
                  {onDelete && (
                    <button
                      type="button"
                      onClick={() => onDelete(prompt.id)}
                      className="btn-secondary text-red-400 hover:text-red-200"
                    >
                      Excluir
                    </button>
                  )}
                  
                </div>
                )}
              </div>
            </div>
);

export default FooterActions;
